// Uzbek (Latin) texts. Orthography: ʻ (U+02BB) in oʻ / gʻ and ʼ (U+02BC) for the tutuq belgisi
// (docs/TELEGRAM_BOT_SPECIFICATION.md §5.2). Wording needs native-speaker review before production.

export const uzLatn = {
  common: {
    noData: 'Maʼlumot yoʻq',
    dash: '—',
    unassigned: 'Biriktirilmagan',
    other: 'Boshqa',
    unknownSource: 'Manbasi koʻrsatilmagan',
  },
  /** Weekday in the dative ("oʻtgan seshanbaga nisbatan"), Monday first. */
  weekdayDative: [
    'dushanbaga',
    'seshanbaga',
    'chorshanbaga',
    'payshanbaga',
    'jumaga',
    'shanbaga',
    'yakshanbaga',
  ],
  sources: {
    facebook: 'Facebook',
    instagram: 'Instagram',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    phone_call: 'Telefon qoʻngʻirogʻi',
    olx: 'OLX',
    website: 'Veb-sayt',
    youtube: 'YouTube',
    referral: 'Tavsiya',
    other: 'Boshqa',
  } as Readonly<Record<string, string>>,
  banner: {
    demo: '🧪 TEST MAʼLUMOTLARI — haqiqiy hisobot emas',
    stale: (lastSync: string) =>
      `⚠️ Diqqat: maʼlumotlar toʻliq boʻlmasligi mumkin (oxirgi sinxronizatsiya: ${lastSync})`,
    neverSynced:
      '⚠️ Diqqat: maʼlumotlar toʻliq boʻlmasligi mumkin (sinxronizatsiya hali boʻlmagan)',
    late: (scheduled: string) => `🕒 Hisobot kechikib yuborildi (rejada: ${scheduled})`,
    resent: '(takroriy yuborish — oldingi xabar yetib bormagan boʻlishi mumkin)',
  },
  report: {
    title: '📊 KUNLIK LIDLAR HISOBOTI',
    titleYesterday: '📊 KECHAGI LIDLAR HISOBOTI',
    asOf: (time: string) => `Maʼlumotlar ${time} holatiga`,
    part: (index: number, total: number) => `${index}/${total}`,
    leads: {
      heading: '📥 LIDLAR',
      new: 'Yangi lidlar',
      contacted: 'Aloqa oʻrnatildi',
      qualified: 'Sifatli lidlar',
      versus: (weekdayDative: string, delta: string) => `oʻtgan ${weekdayDative} nisbatan ${delta}`,
    },
    managers: {
      heading: '👨‍💼 MENEJERLAR',
      row: (name: string, newLeads: number, contacted: number) =>
        `${name}: ${newLeads} yangi lid / ${contacted} aloqa`,
    },
    sources: { heading: '📢 LID MANBALARI' },
    conversion: {
      heading: (days: number) => `📈 KONVERSIYA (oxirgi ${days} kun lidlari)`,
      toQualified: 'Lid → sifatli',
      toDeal: 'Lid → bitim',
      immature: '(davr hali yakunlanmagan)',
    },
    attention: {
      heading: '⚠️ EʼTIBOR TALAB QILADI',
      overdueFollowUps: 'Muddati oʻtgan follow-up',
      uncontacted: (hours: string) => `${hours} soatdan ortiq javobsiz lidlar`,
      withoutSource: 'Manbasi koʻrsatilmagan lidlar',
    },
  },
  bot: {
    unauthorised: (userId: number) =>
      `Kechirasiz, sizda ushbu botdan foydalanish huquqi yoʻq. Administrator bilan bogʻlaning. Telegram ID: ${userId}`,
    start: 'Assalomu alaykum! Men sotuv lidlari boʻyicha hisobot botiman.',
    help: [
      'Mavjud buyruqlar:',
      '/today — bugungi hisobot (hozirgacha)',
      '/yesterday — kechagi hisobot',
      '/sources — lidlar manbalari (bugun va oy boshidan)',
      '/managers — menejerlar boʻyicha lidlar',
      '/report — hisobotni hozir yuborish',
      '/help — shu yordam',
      'Raqamlar "hozirgacha" holatida, agar boshqacha koʻrsatilmagan boʻlsa.',
    ].join('\n'),
    unknownCommand: 'Nomaʼlum buyruq. Buyruqlar roʻyxati: /help',
    privateOnly: 'Bu bot hozircha faqat shaxsiy chatda ishlaydi.',
    rateLimited: 'Hisobot yaqinda yuborilgan. Iltimos, 5 daqiqadan keyin qayta urinib koʻring.',
    failed: 'Hisobotni tayyorlashda xatolik yuz berdi. Keyinroq urinib koʻring.',
    sourcesHeadingToday: 'Bugun',
    sourcesHeadingMonth: 'Oy boshidan',
    managersHeadingToday: 'Bugun',
    managersHeadingMonth: 'Oy boshidan',
    managerFull: (name: string, newLeads: number, contacted: number, overdue: number) =>
      `${name}: ${newLeads} yangi / ${contacted} aloqa / ${overdue} muddati oʻtgan`,
  },
  alert: {
    deliveryFailed: (chatId: number, error: string) =>
      `❗ Hisobot yuborilmadi (chat ${chatId}): ${error}`,
    deliveryUnknown: (chatId: number) =>
      `❗ Hisobot yetib borgani nomaʼlum (chat ${chatId}). Qoʻlda tekshiring.`,
    runFailed: (error: string) => `❗ Hisobotni tayyorlashda xatolik: ${error}`,
    missed: '❗ Rejadagi hisobot oʻz vaqtida yuborilmadi va kechiktirish oynasi tugadi.',
  },
} as const;

export type Catalog = typeof uzLatn;
